import React from "react";

function Nda() {
  return (
    <div className="container mx-auto flex flex-col bg-white p-10 rounded-xl lg:w-1/3 mt-4">
      <h2 className="text-lg font-bold">ダウンロードした資料の取扱規約</h2>
      <p className="pt-4 font-normal">
        <br />
        <br />
        資料提供者（以下「甲」という。）と資料請求者（以下「乙」という。）とは、業務の発注について検討するにあたり（以下「本取引」という。）、甲又は乙が相手方に開示する秘密情報の取扱いについて、以下のとおりの秘密保持契約（以下「本契約」という。）を締結する。
        <br />
        <br />
        第１条（秘密情報）
        <br />
        １．本契約における「秘密情報」とは、甲又は乙が相手方に開示し、かつ開示の際に秘密である旨を明示した技術上又は営業上の情報、本契約の存在及び内容その他一切の情報をいう。ただし、開示を受けた当事者が書面によってその根拠を立証できる場合に限り、以下の情報は秘密情報の対象外とするものとする。
        <br />
        ①　開示を受けたときに既に保有していた情報
        <br />
        ②　開示を受けた後、秘密保持義務を負うことなく第三者から正当に入手した情報
        <br />
        ③　開示を受けた後、相手方から開示を受けた情報に関係なく独自に取得し、又は創出した情報
        <br />
        ④　開示を受けたときに既に公知であった情報
        <br />
        ⑤　開示を受けた後、自己の責めに帰し得ない事由により公知となった情報
        <br />
        ２．前項本文の情報のうち、甲が乙に秘密である旨を指定して開示する情報は別紙１を、また乙が甲に秘密である旨を指定して開示する情報は別紙２を含むものとする。なお、別紙１及び別紙２は甲と乙とが協力し、常に最新の状態を保つべく適切に更新するものとする。（＊４）
        <br />
        ３．甲又は乙が口頭により相手方から開示を受けた情報については、改めて相手方から当該事項について記載した書面の交付を受けた場合に限り、相手方に対し本規程に定める義務を負うものとする。（＊５）
        <br />
        ４．口頭、映像その他その性質上秘密である旨の表示が困難な形態又は媒体により開示、提供された情報については、開示者が相手方に対し、秘密である旨を開示時に伝達し、かつ、当該開示後1日以内に当該秘密情報を記載した書面を秘密である旨の表示をして交付することにより、秘密情報とみなされるものとする。（＊５）
        <br />
        <br />
        第２条（秘密情報等の取扱い）
        <br />
        １．甲又は乙は、相手方から開示を受けた秘密情報及び秘密情報を含む記録媒体若しくは物件（複写物及び複製物を含む。以下「秘密情報等」という。）の取扱いについて、次の各号に定める事項を遵守するものとする。
        <br />
        ①　情報取扱管理者を定め、相手方から開示された秘密情報等を、善良なる管理者としての注意義務をもって厳重に保管、管理する。
        <br />
        ②　秘密情報等は、本取引の目的以外には使用しないものとする。
        <br />
        ③　秘密情報等を複製する場合には、本取引の目的の範囲内に限って行うものとし、その複製物は、原本と同等の保管、管理をする。また、複製物を作成した場合には、複製の時期、複製された記録媒体又は物件の名称を別紙のとおり記録し、相手方の求めに応じて、当該記録を開示する。（＊６）
        <br />
        ④　漏えい、紛失、盗難、盗用等の事態が発生し、又はそのおそれがあることを知った場合は、直ちにその旨を相手方に書面をもって通知する。
        <br />
        ⑤　秘密情報の管理について、取扱責任者を定め、書面をもって取扱責任者の氏名及び連絡先を相手方に通知する。（＊７）
        <br />
        ２．甲又は乙は、次項に定める場合を除き、秘密情報等を第三者に開示する場合には、書面により相手方の事前承諾を得なければならない。この場合、甲又は乙は、当該第三者との間で本契約書と同等の義務を負わせ、これを遵守させる義務を負うものとする。
        <br />
        ３．甲又は乙は、法令に基づき秘密情報等の開示が義務づけられた場合には、事前に相手方に通知し、開示につき可能な限り相手方の指示に従うものとする。
        <br />
        <br />
        第３条（返還義務等）
        <br />
        １．本契約に基づき相手方から開示を受けた秘密情報を含む記録媒体、物件及びその複製物（以下「記録媒体等」という。）は、不要となった場合又は相手方の請求がある場合には、直ちに相手方に返還するものとする。
        <br />
        ２．前項に定める場合において、秘密情報が自己の記録媒体等に含まれているときは、当該秘密情報を消去するとともに、消去した旨（自己の記録媒体等に秘密情報が含まれていないときは、その旨）を相手方に書面にて報告するものとする。
        <br />
        <br />
        第４条（損害賠償等）
        <br />
        甲若しくは乙、甲若しくは乙の従業員若しくは元従業員又は第二条第二項の第三者が相手方の秘密情報等を開示するなど本契約の条項に違反した場合には、甲又は乙は、相手方が必要と認める措置を直ちに講ずるとともに、相手方に生じた損害を賠償しなければならない。
        <br />
        <br />
        第５条（有効期限）
        <br />
        本契約の有効期限は、本契約の締結日から起算し、満1年間とする。期間満了後の1ヵ月前までに甲又は乙のいずれからも相手方に対する書面の通知がなければ、本契約は同一条件でさらに1年間継続するものとし、以後も同様とする。
        <br />
        <br />
        第６条（協議事項）
        <br />
        本契約に定めのない事項について又は本契約に疑義が生じた場合は、協議の上解決する。
        <br />
        <br />
        第７条（管轄）
        <br />
        本契約に関する紛争については東京地方（簡易）裁判所を第一審の専属管轄裁判所とする。
      </p>
    </div>
  );
}

export default Nda;
